import React from 'react';

/** Semantic section wrapper (animation lives on inner motion blocks). */
const ScrollRevealSection = ({ children, className, ...rest }) => (
  <section className={className} {...rest}>
    {children}
  </section>
);

export default ScrollRevealSection;
